/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.
import * as EmployeeBlogListing from 'components/authorable/BeConnected/EmployeeBlogListing/EmployeeBlogListing';
import * as EmployeeRecognition from 'components/authorable/BeConnected/EmployeeRecognition/EmployeeRecognition';
import * as _Category from 'components/authorable/BeConnected/EmployeeRecognition/_Category';
import * as LookerEmbed from 'components/authorable/BeConnected/LookerEmbed/LookerEmbed';
import * as FormUserName from 'components/authorable/form/FormUserName/FormUserName';
import * as FormWrapper from 'components/authorable/form/FormWrapper/FormWrapper';
import * as SitecoreForm from 'components/authorable/form/SitecoreForm/SitecoreForm';
import * as Accordion from 'components/authorable/general/Accordion/Accordion';
import * as AlertBanner from 'components/authorable/general/AlertBanner/AlertBanner';
import * as Banner from 'components/authorable/general/Banner/Banner';
import * as CalloutCard from 'components/authorable/general/CalloutCard/CalloutCard';
import * as CardCollection from 'components/authorable/general/CardCollection/CardCollection';
import * as RoundImageCarousel from 'components/authorable/general/Carousel/RoundImageCarousel';
import * as ChecklistBlock from 'components/authorable/general/ChecklistBlock/ChecklistBlock';
import * as ContentBlock from 'components/authorable/general/ContentBlock/ContentBlock';
import * as IconPanel from 'components/authorable/general/IconPanel/IconPanel';
import * as IFrame from 'components/authorable/general/IFrame/IFrame';
import * as ImageBlock from 'components/authorable/general/ImageBlock/ImageBlock';
import * as captionpanel from 'components/authorable/general/ImageBlock/CaptionPanel/caption-panel';
import * as PageCard from 'components/authorable/general/PageCard/PageCard';
import * as PullQuote from 'components/authorable/general/PullQuote/PullQuote';
import * as quotedown from 'components/authorable/general/PullQuote/SvgQuotes/quote-down';
import * as quoteup from 'components/authorable/general/PullQuote/SvgQuotes/quote-up';
import * as CenterListingByType from 'components/authorable/general/SalesForce/CenterListingByType';
import * as GetCenterTypeColumnValue from 'components/authorable/general/SalesForce/GetCenterTypeColumnValue';
import * as GetParticipatingHospitalColumnValue from 'components/authorable/general/SalesForce/GetParticipatingHospitalColumnValue';
import * as SaleforceTable from 'components/authorable/general/SalesForce/lib/SaleforceTable';
import * as Stats from 'components/authorable/general/Stats/Stats';
import * as Table from 'components/authorable/general/Table/Table';
import * as Tabs from 'components/authorable/general/Tabs/Tabs';
import * as Timeline from 'components/authorable/general/Timeline/Timeline';
import * as Video from 'components/authorable/general/Video/Video';
import * as VideoGallery from 'components/authorable/general/VideoGallery/VideoGallery';
import * as HeroCarousel from 'components/authorable/Heroes/HeroCarousel/HeroCarousel';
import * as HomepageHero from 'components/authorable/Heroes/HomepageHero/HomepageHero';
import * as HomepageHeroNRC from 'components/authorable/Heroes/HomepageHeroNRC/HomepageHeroNRC';
import * as PageHero from 'components/authorable/Heroes/PageHero/PageHero';
import * as PageTitle from 'components/authorable/Heroes/PageTitle/PageTitle';
import * as LayoutFiveColumn from 'components/authorable/layout/LayoutFiveColumn/LayoutFiveColumn';
import * as LayoutFourColumn from 'components/authorable/layout/LayoutFourColumn/LayoutFourColumn';
import * as LayoutLeftThird from 'components/authorable/layout/LayoutLeftThird/LayoutLeftThird';
import * as LayoutPageSection from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import * as LayoutRightThird from 'components/authorable/layout/LayoutRightThird/LayoutRightThird';
import * as LayoutThreeColumn from 'components/authorable/layout/LayoutThreeColumn/LayoutThreeColumn';
import * as LayoutTwoColumn from 'components/authorable/layout/LayoutTwoColumn/LayoutTwoColumn';
import * as Breadcrumb from 'components/authorable/navigation/Breadcrumb/Breadcrumb';
import * as arrowright from 'components/authorable/navigation/Breadcrumb/SvgArrowRight/arrow-right';
import * as DocumentList from 'components/authorable/navigation/DocumentList/DocumentList';
import * as DynamicLinkList from 'components/authorable/navigation/DynamicLinkList/DynamicLinkList';
import * as ManualLinkList from 'components/authorable/navigation/ManualLinkList/ManualLinkList';
import * as QuickLinksList from 'components/authorable/navigation/QuickLinksList/QuickLinksList';
import * as SideNavigation from 'components/authorable/navigation/SideNavigation/SideNavigation';
import * as AnnouncementListing from 'components/authorable/NetworkResourceCenter/AnnouncementListing/AnnouncementListing';
import * as CourierReports from 'components/authorable/NetworkResourceCenter/CourierReports/CourierReports';
import * as CTInstructionHit from 'components/authorable/NetworkResourceCenter/CTInstructions/CTInstructionHit';
import * as CTInstructions from 'components/authorable/NetworkResourceCenter/CTInstructions/CTInstructions';
import * as FeeSchedule from 'components/authorable/NetworkResourceCenter/FeeSchedule/FeeSchedule';
import * as ProductListPage from 'components/authorable/NetworkResourceCenter/ProductListPage/ProductListPage';
import * as Reports from 'components/authorable/NetworkResourceCenter/Reports/Reports';
import * as SearchListing from 'components/authorable/NetworkResourceCenter/SearchListing/SearchListing';
import * as SecureCheckout from 'components/authorable/NetworkResourceCenter/SecureCheckout/SecureCheckout';
import * as CheckoutReview from 'components/authorable/NetworkResourceCenter/SecureCheckout/Components/CheckoutReview';
import * as CheckoutSteps from 'components/authorable/NetworkResourceCenter/SecureCheckout/Components/CheckoutSteps';
import * as MailOrder from 'components/authorable/NetworkResourceCenter/SecureCheckout/Components/MailOrder';
import * as OrderSummary from 'components/authorable/NetworkResourceCenter/SecureCheckout/Components/OrderSummary';
import * as ShippingAddress from 'components/authorable/NetworkResourceCenter/SecureCheckout/Components/ShippingAddress';
import * as ShippingMethod from 'components/authorable/NetworkResourceCenter/SecureCheckout/Components/ShippingMethod';
import * as EventListing from 'components/authorable/news-and-events/EventListing/EventListing';
import * as Anonymous from 'components/authorable/news-and-events/RecentNetworkAnnouncements/Anonymous';
import * as Authenticated from 'components/authorable/news-and-events/RecentNetworkAnnouncements/Authenticated';
import * as RecentNetworkAnnouncements from 'components/authorable/news-and-events/RecentNetworkAnnouncements/RecentNetworkAnnouncements';
import * as RecentNetworkAnnouncementsTypes from 'components/authorable/news-and-events/RecentNetworkAnnouncements/RecentNetworkAnnouncementsTypes';
import * as DoubleTheDonation from 'components/authorable/NmdpSite/DoubleTheDonation/DoubleTheDonation';
import * as TcDirectoryListing from 'components/authorable/NmdpSite/TcDirectoryListing/TcDirectoryListing';
import * as _classes from 'components/authorable/NmdpSite/TcDirectoryListing/_classes';
import * as TcDirectorySearch from 'components/authorable/NmdpSite/TcDirectorySearch/TcDirectorySearch';
import * as types from 'components/authorable/NmdpSite/TcDirectorySearch/types';
import * as _HitsSection from 'components/authorable/NmdpSite/TcDirectorySearch/Helpers/_HitsSection';
import * as _SearchHeading from 'components/authorable/NmdpSite/TcDirectorySearch/Helpers/_SearchHeading';
import * as _SearchHeadings from 'components/authorable/NmdpSite/TcDirectorySearch/Helpers/_SearchHeadings';
import * as AnnouncementPage from 'components/authorable/pages/AnnouncementPage/AnnouncementPage';
import * as AnnouncementV2Page from 'components/authorable/pages/AnnouncementV2Page/AnnouncementV2Page';
import * as ArticlePage from 'components/authorable/pages/ArticlePage/ArticlePage';
import * as CartPage from 'components/authorable/pages/CartPage/CartPage';
import * as CartEntry from 'components/authorable/pages/CartPage/Components/CartEntry';
import * as EmptyCart from 'components/authorable/pages/CartPage/Components/EmptyCart';
import * as EducationPage from 'components/authorable/pages/EducationPage/EducationPage';
import * as EducationPageStoryBook from 'components/authorable/pages/EducationPage/EducationPageStoryBook';
import * as EventPage from 'components/authorable/pages/EventPage/EventPage';
import * as ProductDetailPage from 'components/authorable/pages/ProductDetailPage/ProductDetailPage';
import * as AddToCart from 'components/authorable/pages/ProductDetailPage/Components/AddToCart';
import * as OtherProducts from 'components/authorable/pages/ProductDetailPage/Components/OtherProducts';
import * as ProductImage from 'components/authorable/pages/ProductDetailPage/Components/ProductImage';
import * as RelatedProducts from 'components/authorable/pages/ProductDetailPage/Components/RelatedProducts';
import * as SearchPage from 'components/authorable/pages/SearchPage/SearchPage';
import * as ParticipatingCenter from 'components/authorable/Ritn/ParticipatingCenter/ParticipatingCenter';
import * as index from 'components/authorable/Ritn/ParticipatingCenter/CenterMap/index';
import * as _CenterMapComponent from 'components/authorable/Ritn/ParticipatingCenter/CenterMap/_CenterMapComponent';
import * as _types from 'components/authorable/Ritn/ParticipatingCenter/CenterMap/_types';
import * as TableHeading from 'components/authorable/Ritn/ParticipatingCenter/Icon/TableHeading';
import * as FAQSchema from 'components/authorable/seo/faqschema/FAQSchema';
import * as OrganizationSchema from 'components/authorable/seo/organizationschema/OrganizationSchema';
import * as PageSchema from 'components/authorable/seo/pageschema/PageSchema';
import * as Footer from 'components/authorable/site/Footer/Footer';
import * as PublicisFooter from 'components/authorable/site/Footer/PublicisFooter';
import * as Gtm from 'components/authorable/site/GoogleTagManager/Gtm';
import * as Header from 'components/authorable/site/Header/Header';
import * as PublicisHeader from 'components/authorable/site/Header/PublicisHeader';
import * as account from 'components/authorable/site/Header/SvgAccount/account';
import * as arrowdown from 'components/authorable/site/Header/SvgArrowDown/arrow-down';
import * as cart from 'components/authorable/site/Header/SvgCart/cart';
import * as menu from 'components/authorable/site/Header/SvgMenu/menu';
import * as nrcmenu from 'components/authorable/site/Header/SvgMenu/nrc-menu';
import * as menuclose from 'components/authorable/site/Header/SvgMenuClose/menu-close';
import * as nrcmenuclose from 'components/authorable/site/Header/SvgMenuClose/nrc-menu-close';
import * as newtab from 'components/authorable/site/Header/SvgNewTab/new-tab';
import * as nrcsearch from 'components/authorable/site/Header/SvgSearch/nrc-search';
import * as search from 'components/authorable/site/Header/SvgSearch/search';
import * as SiteImprove from 'components/authorable/site/SiteImprove/SiteImprove';
import * as MyCenters from 'components/authorable/utility-nav/MyCenters/MyCenters';
import * as MyProfile from 'components/authorable/utility-nav/MyProfile/MyProfile';

const components = new Map();
components.set('EmployeeBlogListing', EmployeeBlogListing);
components.set('EmployeeRecognition', EmployeeRecognition);
components.set('_Category', _Category);
components.set('LookerEmbed', LookerEmbed);
components.set('FormUserName', FormUserName);
components.set('FormWrapper', FormWrapper);
components.set('SitecoreForm', SitecoreForm);
components.set('Accordion', Accordion);
components.set('AlertBanner', AlertBanner);
components.set('Banner', Banner);
components.set('CalloutCard', CalloutCard);
components.set('CardCollection', CardCollection);
components.set('RoundImageCarousel', RoundImageCarousel);
components.set('ChecklistBlock', ChecklistBlock);
components.set('ContentBlock', ContentBlock);
components.set('IconPanel', IconPanel);
components.set('IFrame', IFrame);
components.set('ImageBlock', ImageBlock);
components.set('caption-panel', captionpanel);
components.set('PageCard', PageCard);
components.set('PullQuote', PullQuote);
components.set('quote-down', quotedown);
components.set('quote-up', quoteup);
components.set('CenterListingByType', CenterListingByType);
components.set('GetCenterTypeColumnValue', GetCenterTypeColumnValue);
components.set('GetParticipatingHospitalColumnValue', GetParticipatingHospitalColumnValue);
components.set('SaleforceTable', SaleforceTable);
components.set('Stats', Stats);
components.set('Table', Table);
components.set('Tabs', Tabs);
components.set('Timeline', Timeline);
components.set('Video', Video);
components.set('VideoGallery', VideoGallery);
components.set('HeroCarousel', HeroCarousel);
components.set('HomepageHero', HomepageHero);
components.set('HomepageHeroNRC', HomepageHeroNRC);
components.set('PageHero', PageHero);
components.set('PageTitle', PageTitle);
components.set('LayoutFiveColumn', LayoutFiveColumn);
components.set('LayoutFourColumn', LayoutFourColumn);
components.set('LayoutLeftThird', LayoutLeftThird);
components.set('LayoutPageSection', LayoutPageSection);
components.set('LayoutRightThird', LayoutRightThird);
components.set('LayoutThreeColumn', LayoutThreeColumn);
components.set('LayoutTwoColumn', LayoutTwoColumn);
components.set('Breadcrumb', Breadcrumb);
components.set('arrow-right', arrowright);
components.set('DocumentList', DocumentList);
components.set('DynamicLinkList', DynamicLinkList);
components.set('ManualLinkList', ManualLinkList);
components.set('QuickLinksList', QuickLinksList);
components.set('SideNavigation', SideNavigation);
components.set('AnnouncementListing', AnnouncementListing);
components.set('CourierReports', CourierReports);
components.set('CTInstructionHit', CTInstructionHit);
components.set('CTInstructions', CTInstructions);
components.set('FeeSchedule', FeeSchedule);
components.set('ProductListPage', ProductListPage);
components.set('Reports', Reports);
components.set('SearchListing', SearchListing);
components.set('SecureCheckout', SecureCheckout);
components.set('CheckoutReview', CheckoutReview);
components.set('CheckoutSteps', CheckoutSteps);
components.set('MailOrder', MailOrder);
components.set('OrderSummary', OrderSummary);
components.set('ShippingAddress', ShippingAddress);
components.set('ShippingMethod', ShippingMethod);
components.set('EventListing', EventListing);
components.set('Anonymous', Anonymous);
components.set('Authenticated', Authenticated);
components.set('RecentNetworkAnnouncements', RecentNetworkAnnouncements);
components.set('RecentNetworkAnnouncementsTypes', RecentNetworkAnnouncementsTypes);
components.set('DoubleTheDonation', DoubleTheDonation);
components.set('TcDirectoryListing', TcDirectoryListing);
components.set('_classes', _classes);
components.set('TcDirectorySearch', TcDirectorySearch);
components.set('types', types);
components.set('_HitsSection', _HitsSection);
components.set('_SearchHeading', _SearchHeading);
components.set('_SearchHeadings', _SearchHeadings);
components.set('AnnouncementPage', AnnouncementPage);
components.set('AnnouncementV2Page', AnnouncementV2Page);
components.set('ArticlePage', ArticlePage);
components.set('CartPage', CartPage);
components.set('CartEntry', CartEntry);
components.set('EmptyCart', EmptyCart);
components.set('EducationPage', EducationPage);
components.set('EducationPageStoryBook', EducationPageStoryBook);
components.set('EventPage', EventPage);
components.set('ProductDetailPage', ProductDetailPage);
components.set('AddToCart', AddToCart);
components.set('OtherProducts', OtherProducts);
components.set('ProductImage', ProductImage);
components.set('RelatedProducts', RelatedProducts);
components.set('SearchPage', SearchPage);
components.set('ParticipatingCenter', ParticipatingCenter);
components.set('index', index);
components.set('_CenterMapComponent', _CenterMapComponent);
components.set('_types', _types);
components.set('TableHeading', TableHeading);
components.set('FAQSchema', FAQSchema);
components.set('OrganizationSchema', OrganizationSchema);
components.set('PageSchema', PageSchema);
components.set('Footer', Footer);
components.set('PublicisFooter', PublicisFooter);
components.set('Gtm', Gtm);
components.set('Header', Header);
components.set('PublicisHeader', PublicisHeader);
components.set('account', account);
components.set('arrow-down', arrowdown);
components.set('cart', cart);
components.set('menu', menu);
components.set('nrc-menu', nrcmenu);
components.set('menu-close', menuclose);
components.set('nrc-menu-close', nrcmenuclose);
components.set('new-tab', newtab);
components.set('nrc-search', nrcsearch);
components.set('search', search);
components.set('SiteImprove', SiteImprove);
components.set('MyCenters', MyCenters);
components.set('MyProfile', MyProfile);

export function componentModule(componentName: string) {
  return components.get(componentName);
};

export function componentFactory(componentName: string) {
  return components.get(componentName)?.default;
};
